import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const FilterIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M10.725 16.7V16h2.525v.7h-2.525ZM7.05 12.35v-.7h9.875v.7H7.05ZM4.3 8v-.7h15.4V8H4.3Z"
            />
        </svg>
    </IconWrapper>
));
